var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 0.166504C2.77984 0.166504 0.166504 2.77984 0.166504 5.99984C0.166504 9.21984 2.77984 11.8332 5.99984 11.8332C9.21984 11.8332 11.8332 9.21984 11.8332 5.99984C11.8332 2.77984 9.21984 0.166504 5.99984 0.166504ZM5.99984 8.9165C5.679 8.9165 5.4165 8.654 5.4165 8.33317V5.99984C5.4165 5.679 5.679 5.4165 5.99984 5.4165C6.32067 5.4165 6.58317 5.679 6.58317 5.99984V8.33317C6.58317 8.654 6.32067 8.9165 5.99984 8.9165ZM6.58317 4.24984H5.4165V3.08317H6.58317V4.24984Z",
    fill: "#959595"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoGray);
export default __webpack_public_path__ + "static/media/icon_info-gray.bbcb4008c39a8a0d62431c148a2604ad.svg";
export { ForwardRef as ReactComponent };